(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-improved"]) return;
  try {
    
  (() => {
    const buildArticleLayout = (root) => {
      const inner = root.querySelector('.rt-article__inner');
      if (!inner || inner.querySelector('.rt-article__layout')) return;
      const layout = document.createElement('div');
      const main = document.createElement('div');
      const sidebar = document.createElement('aside');
      layout.className = 'rt-article__layout';
      main.className = 'rt-article__main';
      sidebar.className = 'rt-article__sidebar';
      sidebar.setAttribute('aria-label', 'Article sidebar');
      const header = inner.querySelector('.rt-article__header');
      if (header && header.parentElement === inner) inner.insertBefore(layout, header);
      else inner.appendChild(layout);
      ['.rt-article__header', '.rt-article__hero', '.rt-article__content', '.rt-article__product-cta', '.rt-article__comments'].forEach((selector) => {
        const element = inner.querySelector(selector);
        if (element) main.appendChild(element);
      });
      main.querySelectorAll('.rt-article__content p').forEach((paragraph) => {
        const text = paragraph.textContent.trim();
        const letters = text.replace(/[^A-Za-z]/g, '');
        if (text.length > 3 && text.length < 90 && letters.length > 3 && text === text.toUpperCase() && !paragraph.querySelector('img, a, button')) {
          const heading = document.createElement('h2');
          heading.innerHTML = paragraph.innerHTML;
          paragraph.replaceWith(heading);
        }
      });
      const titleCase = (value) => {
        const acronyms = new Set(['svg', 'png', 'dxf', 'zip', 'faq']);
        return value.toLowerCase().replace(/\b[a-z]+\b/g, (word) => {
          if (acronyms.has(word)) return word.toUpperCase();
          return word.charAt(0).toUpperCase() + word.slice(1);
        });
      };
      main.querySelectorAll('.rt-article__content h2, .rt-article__content h3').forEach((heading) => {
        heading.textContent = titleCase(heading.textContent.trim());
      });
      if (root.dataset.showToc === 'true') {
        const headings = main.querySelectorAll('.rt-article__content h2, .rt-article__content h3');
        if (headings.length) {
          const toc = document.createElement('nav');
          const title = document.createElement('h2');
          const list = document.createElement('ol');
          toc.className = 'rt-article__sidebar-card';
          toc.setAttribute('aria-label', 'On this page');
          title.textContent = 'On This Page';
          list.className = 'rt-article__toc-list';
          headings.forEach((heading, index) => {
            if (!heading.id) heading.id = `article-heading-${root.dataset.sectionId}-${index + 1}`;
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent;
            item.appendChild(link);
            list.appendChild(item);
          });
          toc.append(title, list);
          sidebar.appendChild(toc);
        }
      }
      inner.querySelectorAll(':scope > .rt-article__related, :scope > .rt-article__newsletter').forEach((element) => sidebar.appendChild(element));
      layout.append(main, sidebar);
    };
    document.querySelectorAll('.rt-article').forEach(buildArticleLayout);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.rt-article').forEach(buildArticleLayout);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
